
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11 0c6.075 0 11 4.925 11 11s-4.925 11-11 11S0 17.075 0 11 4.925 0 11 0zm1.195 4.514c-.719-.159-1.974-.361-3.415.318-.932.44-1.458 1.298-1.59 1.64-.107.294-.23.738.199.99.255.11.75.16 1.482.149.282-.022.37-.198.53-.431.16-.233.49-.838 1.232-.946.741-.108 1.383.116 1.383.676v1.26l-.035.06c-.068.091-.193.136-.374.136-.217 0-.645.007-1.283.02-1.303.093-2.272.594-2.905 1.5-.95 1.361-.733 3.544.752 4.206 1.486.66 2.594.206 3.08-.113.323-.213.623-.43.899-.648.192-.06.325-.04.401.061.076.101.271.323.586.665.156.185.523.288.755.108l1.087-1.036.06-.085c.103-.173.104-.363.004-.57-.33-.5-.533-.816-.607-.947-.097-.173-.109-.303-.11-.597V7.18l-.008-.107c-.074-.841-.517-2.204-2.123-2.56zm-.239 5.132l.092.005c.059.701-.002 1.247-.181 1.638-.523.885-1.362 1.237-1.933 1.004-.571-.234-.73-.813-.245-1.59.486-.778 1.933-1.105 2.359-1.052l-.092-.005z","fill":"#333E48"}}),_c('path',{attrs:{"d":"M3.667 14.789c.085.035 1.771.884 3.504 1.282 1.135.261 2.923.498 4.78.332 2.207-.197 3.349-.487 4.204-.78.844-.29.852-.272.949-.28.097-.01.28.09.097.331-.074.098-.94.76-2.2 1.257-1.108.436-2.474.678-3.638.72-1.165.043-1.973.013-2.984-.164-1.197-.21-2.33-.612-3.07-1.04-.913-.525-1.545-.967-1.895-1.324-.13-.153-.16-.264-.093-.334.102-.105.243-.043.346 0zm12.44-.43c.51-.222 1.222-.32 1.957-.221.735.098.69.22.657.754a3.334 3.334 0 01-.345 1.179c-.222.417-.51.775-.627.89-.225.218-.255 0-.225-.157s.225-.803.305-1.173c.08-.37.113-.647 0-.718-.113-.07-.678-.145-1.345-.145-.666 0-.78-.007-.814-.074-.035-.067.134-.204.437-.335z","fill":"#F90"}})])
          )
        }
      }
    